<script setup>
const props = defineProps({
    carouselCards: {
        type: Array,
        required: true,
    },
    anchorId: {
        type: String,
    },
});

const totalCards = props.carouselCards.length;

const currentIndex = ref(0);

function forward() {
    currentIndex.value >= totalCards - 1 ? (currentIndex.value = 0) : (currentIndex.value += 1);
}

function backward() {
    currentIndex.value <= 0 ? (currentIndex.value = totalCards - 1) : (currentIndex.value -= 1);
}

function jump(newValue) {
    currentIndex.value <= newValue ? currentIndex.value = newValue : currentIndex.value = 0;
}

const currentCaption = computed(() => {
    return props.carouselCards[currentIndex.value].caption;
})

</script>

<template>
    <section class="block block-blog-image-carousel" :id="anchorId || null" tabindex="-1">
        <div class="container">
            <div class="inner-container">
                <div class="carousel-container" ref="carouselContainer" :style="`--fraction: ${100 / totalCards}%`">
                    <ProjectSimpleCarousel :carouselWidth="`${carouselCards.length * 100}%`" :stepLength="`${currentIndex * 100}%`" :currentIndex="currentIndex" :number-of-slides="carouselCards.length">
                        <FragmentsCardsCaptionBox v-for="(card, index) in carouselCards" :card="card" :key="index" :style="`--offset: ${index}`" hideCaption />
                    </ProjectSimpleCarousel>
                </div>
                <div class="carousel-controls flex gap-11.25 items-start mt-7">
                    <div class="controls flex items-center gap-11.25">
                        <div class="carousel-arrows flex gap-4.5">
                            <button @click="backward" class="back-arrow text-(--teal)" title="Move the carousel back one slide" :disabled="currentIndex <= 0">
                                <MessSvg type="back-arrow-small"></MessSvg>
                            </button>
                            <button @click="forward" class="forward-arrow text-(--teal)" title="Move the carousel forward one slide" :disabled="currentIndex >= carouselCards.length - 1">
                                <MessSvg type="forward-arrow-small"></MessSvg>
                            </button>
                        </div>
                        <FragmentsCarouselsControlsDot color="var(--teal-dark)" background="var(--cream-light)" :itemTotal="carouselCards.length" :activeIndex="currentIndex" @updateIndex="jump" />
                    </div>
                    <div class="carousel-caption ml-auto text-(--teal-gray) text-[calc(15/var(--base-fs)*1rem)] font-light tracking-[0.01875rem] leading-6.25 text-left" v-html="currentCaption"></div>
                </div>
            </div>
        </div>
    </section>
</template>

<style>
/* [calc] max-height on carousel list */
.block-blog-image-carousel .simple-carousel ul {
    position: relative;
    max-height: calc(75 * var(--vh));
}

/* [child] image border-radius in carousel cards */
.block-blog-image-carousel .simple-carousel ul li.caption-card .mess-image {
    border-radius: var(--radius);
    object-fit: cover;
}

/* [child] img tag border-radius */
.block-blog-image-carousel .simple-carousel ul li.caption-card .mess-image img {
    border-radius: var(--radius);
    object-fit: cover;
}

/* [state] disabled arrow opacity */
.block-blog-image-carousel .carousel-arrows button[disabled] {
    opacity: 0.25;
}

/* [child] arrow svg color */
.block-blog-image-carousel .carousel-arrows button svg {
    color: var(--teal);
}

/* [state] arrow hover */
@media (hover: hover) {
    .block-blog-image-carousel .carousel-arrows button:hover svg {
        color: var(--orange-dark);
    }

    .block-blog-image-carousel .controls .dot-button:hover {
        fill: var(--orange-dark);
    }
}
</style>
